import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=fbb52c90&scoped=true&"
var script = {}
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=fbb52c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb52c90",
  null
  
)

export default component.exports